// Validation contract for Step 1 of the Campaign Forge V2 wizard.
// Returns true iff the Begin step is complete enough for the user to
// advance to Step 2. Ported verbatim from
// prototypes/campaign-creation-prototype.jsx canAdvance helper (lines
// 2864-2875). Pure function; no side effects.

export const validateBeginStep = (form) => {
  if (!form || typeof form.name !== 'string' || form.name.trim().length === 0) {
    return false;
  }
  if (form.origin === 'template') {
    return !!form.templateId;
  }
  if (form.origin === 'existing') {
    return !!form.existingId;
  }
  // origin === 'scratch' — validate world association.
  if (form.worldMode === 'existing') {
    return !!form.worldId;
  }
  if (form.worldMode === 'new') {
    return typeof form.newWorldName === 'string' && form.newWorldName.trim().length > 0;
  }
  // 'isolated' or any unset mode — always OK once name is non-empty.
  return true;
};
